import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { TitleWithIcon } from 'Components/TitleWithIcon/TitleWithIcon';
import { ReactComponent as Copy } from 'Assets/controls/copy.svg';
import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { useAppDispatch } from 'Redux/store';
import {
  stringToMiles,
  formatDims,
  anyStringToDigitsString,
  camelCaseToSeparatedWords,
} from 'Shared/Utils';
import styles from './InfoBlock.module.scss';

export const InfoBlock: React.FC = () => {
  const currentOrder = useSelector(selectCurrentOrder);
  const dispatch = useAppDispatch();
  const [data, setData] = useState({
    loaded: '',
    pieces: '',
    dims: '',
    weight: '',
    truckSize: '',
    notes: '',
  });
  const [notificationAPI, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (currentOrder) {
      const { line, pieces, dimensions, weight, vehicle_required, notes, transit_distance } =
        currentOrder;
      const miles = stringToMiles(line) || transit_distance;

      setData({
        loaded: miles ? `${miles} mi` : '',
        pieces,
        dims: formatDims(dimensions),
        weight: anyStringToDigitsString(weight),
        truckSize: vehicle_required,
        notes,
      });
    }
  }, [currentOrder, dispatch]);

  const copyOrderInfoHandler = () => {
    navigator.clipboard.writeText(
      Object.entries(data)
        .map((entry) =>
          entry[1]
            ? `${camelCaseToSeparatedWords(entry[0])}\n${entry[1]}`
            : null,
        )
        .filter(Boolean)
        .join('\n\n'),
    );

    notificationAPI.success({
      message: 'Order information was copied',
      duration: 2,
    });
  };

  return (
    <div className={styles.info}>
      {contextHolder}

      <TitleWithIcon
        content="Information"
        icon={Copy}
        iconTitle="Copy order additional information"
        iconClickHandler={copyOrderInfoHandler}
        customStyles={styles.info__icon}
      />

      <div className={styles.info__body}>
        <ul>
          <li className={styles.info__row}>
            <div className={styles.info__row__title}>Loaded</div>
            <div className={styles.info__row__content}>{data?.loaded}</div>
          </li>
          <li className={styles.info__row}>
            <div className={styles.info__row__title}>Pieces</div>
            <div className={styles.info__row__content}>{data?.pieces}</div>
          </li>
          <li className={styles.info__row}>
            <div className={styles.info__row__title}>Dims</div>
            <div className={styles.info__row__content}>{data?.dims}</div>
          </li>
          <li className={styles.info__row}>
            <div className={styles.info__row__title}>Weight</div>
            <div className={styles.info__row__content}>{data?.weight}</div>
          </li>
          <li className={styles.info__row}>
            <div className={styles.info__row__title}>Truck size</div>
            <div className={styles.info__row__content}>{data?.truckSize}</div>
          </li>
          <li className={styles.info__row}>
            <div className={styles.info__row__title}>Notes</div>
            <div className={styles.info__row__content}>{data?.notes}</div>
          </li>
        </ul>
      </div>
    </div>
  );
};
